import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLastScore, setScore } from "../../../config/redux/engineSlice";
import "./Score.css";

const Score = () => {
  const score = useSelector((state) => state.engine.score);
  const lastScore = useSelector((state) => state.engine.lastScore);
  const play = useSelector((state) => state.engine.play);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!play && score !== 0) {
      dispatch(setLastScore(0));
    }
  }, [dispatch, play, score]);

  useEffect(() => {
    if (play) {
      dispatch(setScore(0)); // Reset score on game start
    }
  }, [dispatch, play]);

  return (
    <div className="score-container">
      <p className="scoremario">Score: {play ? score : lastScore}</p>
    </div>
  );
};

export default Score;
